import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import purpleArrow from '../../images/arrow-purple-down.svg';

const Section = ({ title, children, initialOpen = false }) => {
  const [open, setOpen] = useState(initialOpen);

  return (
    <OuterContainer>
      <Header className={open ? 'active' : ''} onClick={() => setOpen(!open)}>{title}</Header>

      <ContentContainer open={open}>
        {children}
      </ContentContainer>
    </OuterContainer>
  );
};

const OuterContainer = styled.div`
`;

const Header = styled.h4`
  position: relative;
  cursor: pointer;
  user-select: none;
  font-size: 16px;
  transition: color 0.25s;
  &:before {
    content: "";
    background-image: url(${purpleArrow});
    background-size: cover;
    transform: rotate(-90deg);
    position: absolute;
    right: 0;
    transition: all 0.25s ease;
    width: 24px;
    height: 24px;
  }
  &.active:before{
    transform: rotate(0);
  }
  &:hover {
    color: ${(props) => props.theme.brandPurple};
  }
`;

const ContentContainer = styled.div`
  overflow: hidden;
  ${({ open }) => open ?
    'height: auto;' :
    'height: 0;'
}
`;

Section.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  initialOpen: PropTypes.bool,
};

export default Section;



// WEBPACK FOOTER //
// ./app/components/Section/index.js